module.exports = __webpack_public_path__ + "static/img/abuous01.fa34612.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutsUs/abuous01.png
// module id = Fjyn
// module chunks = 1